import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const updateFinixComplianceForm = (axios: IAxiosInstance) => {
  return async (params: {
    companyID: string;
    formId: string;
    name: string;
    title: string;
  }) => {
    const response = await axios.noRetry.post<IApiResponse<any>>(
      `/api/business-cards/finix-compliance-form`,
      {
        companyID: params.companyID,
        formId: params.formId,
        name: params.name,
        title: params.title,
      }
    );

    return response.data;
  };
};
